import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import classes from "./DisciplinesFilterList.module.css"
import { FilterExtention, Filter, FilterTypesEnum, Filters, FilterItem } from "../../../UI/Filter";
import { getMaxValue } from '../../../../utils'
import Disciplines from "./Disciplines";
import { getCoursesData } from "../../../../store/discipline-action";

const DisciplinesFilterList = ({ selectDisciplineCB }) => {
    const { texts, lang } = useSelector(state => state.translate);
    const direction = useSelector(state => state.translate.direction);
    const { years } = useSelector(state => state.studyYears);
    const dispatch = useDispatch()

    const applicationId = useSelector(state => state.application.applicationId);

    const disciplines = useSelector(state => state.disciplines);
    const componentMounted = useRef(true);

    useEffect(() => {
        //the current year is the max year from disciplines
        if (applicationId && (!disciplines || !disciplines.find(d => d.year < getMaxValue(disciplines, 'year')))) {
            const includePastYears = true
            dispatch(getCoursesData(includePastYears));
        }
    }, [applicationId])

    useEffect(() => {
        return () => {
            componentMounted.current = false;
        }
    }, [])

    return (
        <div className={`${classes[direction]} ${classes.CoursesPageOverflow}`} >
            <div className={classes.CoursesPage}>
                <FilterExtention
                    list={disciplines && disciplines.map(d => {
                        const literalYear = years && years[`${d?.year}`] && years[`${d?.year}`][lang]
                        return { ...d, literalYear: literalYear }
                    })}
                >
                    <Filters>
                        <Filter name="free" text={texts.freeFilter} type={FilterTypesEnum.free}></Filter>
                        <Filter name="name" text={texts.filterByDiscipline} type={FilterTypesEnum.values}></Filter>
                        <Filter name="literalYear" text={texts.filterByYear} type={FilterTypesEnum.values}></Filter>
                        <Filter name="lang" text={texts.filterByLanguage} type={FilterTypesEnum.valuesList} values={{ he: texts.he, ar: texts.ar }}></Filter>
                        <Filter name="active" text={texts.filterByStatus} type={FilterTypesEnum.valuesList} values={{ true: texts.active, false: texts.noActive }}></Filter>
                    </Filters>
                    <FilterItem>
                        <Disciplines isEditable={true} selectDisciplineCB={selectDisciplineCB} addNew={true} />
                    </FilterItem>
                </FilterExtention>
            </div>
        </div>
    )
}

export default DisciplinesFilterList;